import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import OverviewCover from '@/assets/images/overviewCover.png';

const ProtectionPurpose: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const words = gsap.utils.toArray<HTMLElement>('.word');
    gsap.set(words, { color: '#6b7280' });

    gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: 'top 75%',
        end: 'bottom 30%',
        scrub: true,
      },
    }).to(words, {
      color: '#ffffff',
      stagger: 0.1,
      ease: 'none',
    });

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  const animatedText =
    'We’re all about making life easier, and we prove that from the start. ' +
    'Integrating Protega is simple — no matter what commerce platform you use. ' +
    'Our team handles everything from automating claim support to preventing fraud and more. ' +
    'We do the heavy lifting. You just flip on the switch.';

  return (
    <section
      ref={sectionRef}
      className="tw-relative tw-w-full tw-min-h-screen tw-overflow-hidden tw-bg-black tw-text-white"
    >
      {/* Background */}
      <div className="tw-absolute tw-inset-0 tw-z-0">
        <div className="tw-top-0 tw-h-full tw-w-full tw-relative">
          <img
            ref={imageRef}
            src={OverviewCover}
            alt="Background"
            className="tw-w-full tw-h-full tw-object-cover tw-filter tw-grayscale"
            style={{
              WebkitMaskImage:
                'linear-gradient(to right, black 0%, transparent 65%)',
              maskImage:
                'linear-gradient(to right, black 0%, transparent 65%)',
            }}
          />
        </div>
      </div>

      {/* Text block */}
      <div className="tw-relative tw-z-10 tw-flex tw-items-center tw-justify-end tw-h-full tw-pt-80 tw-px-6 md:tw-pt-24 md:tw-px-12 lg:tw-px-24">
        <div ref={textRef} className="tw-max-w-lg tw-w-full md:tw-w-1/2 tw-text-right">
          <p className="tw-text-xl md:tw-text-2xl lg:tw-text-4xl tw-font-bold tw-tracking-wide tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-1">
            {animatedText.split(' ').map((word, i) => (
              <span key={i} className="word tw-inline-block">
                {word}
              </span>
            ))}
          </p>
        </div>
      </div>

    </section>
  );
};

export default ProtectionPurpose;
